import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';

export const getVyhlasovanieVZbierke = async ():
  Promise<ClientResponse<string>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/vyhlasovanie-v-zbierke',
  );

  return {
    data: data.results[0].text,
    responseCode: status,
  };
};
